import { differenceInMonths } from 'date-fns';

export const langs = ['en', 'es'];

export const langsToText = {
  en: 'English',
  es: 'Español',
};

export const monthsToBeANewListing = 4;
export const isNewListing = (createdAt: Date) =>
  differenceInMonths(new Date(), createdAt) < monthsToBeANewListing;

export const urlValidationRegex =
  /(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#()?&//=]*)/;

export const termsUrl = (locale: string) =>
  locale === 'es'
    ? `${process.env.NEXT_PUBLIC_CONNECT_AMERICAS_URL}/es/content/t%C3%A9rminos-y-condiciones`
    : `${process.env.NEXT_PUBLIC_CONNECT_AMERICAS_URL}/content/terms-and-conditions-0`;
export const privacyUrl = (locale: string) =>
  locale === 'es'
    ? `${process.env.NEXT_PUBLIC_CONNECT_AMERICAS_URL}/es/content/pol%C3%ADticas-de-privacidad`
    : `${process.env.NEXT_PUBLIC_CONNECT_AMERICAS_URL}/content/privacy-policy`;

export const CA_VERIFICATIONS_EMAIL = 'verifications@connectamericas.com';
